import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {makeStyles} from 'tss-react/mui';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';

//Iconos

//DS
import {openMsg} from 'src/redux-app';
import {showSucces} from 'src/common/toast';
import {hooks, SelectPlus, FmBase} from 'lib.front';
import {esquemaCampos, esquemaValidacion, esquemaQuery} from './esquemas';
import {cmps} from './constantes';
import {Box} from '@mui/material';

const {useValidacion} = hooks;

//Estilos del componente
const useStyles = makeStyles()(theme => ({
   container: {
      display: 'flex',
      flexWrap: 'wrap'
   },
   textField: {
      width: '100%'
   },
   margin: {
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1)
   },
   clave: {
      width: '30%'
   },
   marginContainer: {
      marginTop: '64px'
   }
}));
// componentes auxiliares

//Componente principal
const Version = props => {
   const dispatch = useDispatch();
   const {classes, cx} = useStyles();
   //--Notificaciones

   function mensajeExito(data) {
      showSucces('Los datos se actualizarón correctamente');
   }

   //--Modal para mensajes
   function msgError(err) {
      dispatch(openMsg(JSON.stringify(err)));
   }

   //Obtenemos estados de informacion y objetos para su manejo y validacion
   const {
      campos,
      existeError: existeErrorInput,
      handleOnChange,
      inicializar,
      setCampo,
      validarTodos,
      validacionManual
   } = useValidacion(esquemaCampos, esquemaValidacion);

   //Estados de control del formulario
   const [disabled, setDisabled] = useState(false);

   //Estados para representar los datos

   /*
    Efectos
    */
   /*
    Funciones para manejar el cambio en los estados de datos, modificar o aumentar funciones de ser necesario
    */

   /*
    Funciones a sobreescribir para personalizar el modulo
    */
   const inicializarFormulario = () => {
      inicializar();
   };
   //
   async function generarParametros() {
      const params = {
         codigo: campos.codigo.valor.value,
         denominacion: campos.denominacion.valor,
         estado: campos.estado.valor
      };
      return params;
   }
   //
   const asignarValoresEstados = async data => {
      setCampo('denominacion', data.denominacion);
      setCampo('estado', data.estado);
   };

   const handleChangeEstado = event => {
      setCampo('estado', event.target.checked ? 1 : 0);
   };
   //Variables locales

   //Componentes auxiliares
   const clave = () => {
      return (
         <Box className={classes.clave}>
            <SelectPlus
               name={cmps.CODIGO}
               label="Código"
               entidad="versiones"
               campos={['codigo', 'denominacion']}
               value={campos.codigo.valor}
               onChange={elegido => {
                  validacionManual('codigo', elegido);
               }}
               genId={registro => {
                  return registro.codigo;
               }}
               genLabel={registro => {
                  return `${registro.codigo} - ${registro.denominacion} `;
               }}
               error={campos.codigo.error !== ''}
               helperText={campos.codigo.error}
               InputLabelProps={{shrink: true}}
               disabled={disabled}
               variant="outlined"
               margin="dense"
               isClearable
               excesoElementos
               permitirNuevosValores
               recuperarOnFocus
            />
         </Box>
      );
   };

   return (
      <Container
         className={cx('containerbox', props.tipoModal && classes.marginContainer)}
         maxWidth="md"
      >
         <FmBase
            titulo="Versión"
            entidad="version"
            inicializar={inicializarFormulario}
            campos={esquemaQuery}
            generarParametros={generarParametros}
            asignarValoresEstados={asignarValoresEstados}
            existeErrorInput={existeErrorInput}
            validarTodos={validarTodos}
            clave={clave}
            setDisabled={setDisabled}
            open={props.open}
            handleCloseModal={props.handleCloseModal}
            mostrarMensajeExito={mensajeExito}
            mostrarMensajeError={msgError}
            //llamarRecuperar
         >
            <TextField
               name={cmps.DENOMINACION}
               label="Denominación"
               value={campos.denominacion.valor}
               onChange={handleOnChange}
               error={campos.denominacion.error !== ''}
               helperText={campos.denominacion.error}
               className={classes.textField}
               disabled={!disabled}
               variant="outlined"
               margin="dense"
               required
            />
            <FormControlLabel
               control={
                  <Switch
                     checked={campos.estado.valor}
                     onChange={handleChangeEstado}
                     name="checkedA"
                     inputProps={{'aria-label': 'secondary checkbox'}}
                  />
               }
               label="Estado"
            />
         </FmBase>
      </Container>
   );
};

export default Version;
